<template>
  <div class="list-section">
    <!-- 顶部区域：搜索区域 -->
    <div class="search-bg">
      <!-- 搜索表单 -->
      <el-form :inline="true" :model="filters">
        <el-row :gutter="22">
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text111') + '：'"
              class="search-label"
            >
              <el-input v-model="filters.webAccount" placeholder="" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text88') + '：'"
              class="search-label"
            >
              <el-input v-model="filters.customerName" placeholder="" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text216') + '：'"
              class="search-label"
            >
              <el-input v-model="filters.mt4Account" placeholder="" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text253') + '：'"
              class="selector-search-label"
            >
              <el-select v-model="filters.depositType" placeholder="" clearable>
                <el-option
                  v-for="item in depositTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$t('followOrder.text71') + '：'"
              class="selector-search-label"
            >
              <el-select v-model="filters.status" placeholder="" clearable>
                <el-option
                  v-for="item in statuses"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="handleSearch"
              class="search-button"
              >{{ $t("proxy.text13") }}</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="list-spacer"></div>

    <!-- 中间区域：资金统计 -->
    <div class="overview-container">
      <span class="summary-title"
        >{{ $t("AccountAssets.text12") }}：<span class="summary-text">{{
          totalRecharge
        }}</span></span
      >
      <span class="summary-title"
        >{{ $t("AccountAssets.text13") }}：<span class="summary-text">{{
          totalWallet
        }}</span></span
      >
      <span class="summary-title"
        >{{ $t("proxy.text136") }}：<span class="summary-text">{{
          netRecharge
        }}</span></span
      >
    </div>

    <div class="list-spacer"></div>

    <!-- 出入金列表表格 -->
    <div class="table-container">
      <el-table
        :data="filteredCustomerList"
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column
          min-width="120px"
          prop="flowId"
          align="center"
          :label="$t('proxy.text144')"
        />
        <el-table-column
          min-width="180px"
          prop="fundAccountName"
          align="center"
          :label="$t('proxy.text88')"
        >
          <template #default="{ row }">
            <span>{{ row.fundAccountName ? row.fundAccountName : "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="120px"
          prop="fundAccountId"
          align="center"
          :label="$t('proxy.text111')"
        />
        <el-table-column
          min-width="120px"
          prop="mt4LoginId"
          align="center"
          :label="$t('proxy.text216')"
        >
          <template #default="{ row }">
            <span>{{ row.mt4LoginId ? row.mt4LoginId : "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="agentConfig.phoneLoginReg"
          min-width="150px"
          prop="phone"
          align="center"
          :label="$t('proxy.text89')"
        >
          <template #default="{ row }">
            <div class="break-word">
              {{ row.phone ? row.phone : "--" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="agentConfig.emailLoginReg"
          min-width="250px"
          prop="email"
          align="center"
          :label="$t('proxy.text34')"
        >
          <template #default="scope">
            <div class="break-word">
              {{ scope.row.email ? scope.row.email : "--" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          min-width="180px"
          prop="bizName"
          align="center"
          :label="$t('proxy.text253')"
        />
        <el-table-column
          min-width="150px"
          prop="currencyAmount"
          align="center"
          :label="$t('proxy.text254')"
        />
        <el-table-column
          min-width="150px"
          prop="amount"
          align="center"
          :label="$t('proxy.text255')"
        />
        <el-table-column
          min-width="130px"
          prop="statusDesc"
          align="center"
          :label="$t('proxy.text46')"
        />
        <el-table-column
          min-width="130px"
          prop="bizTime"
          align="center"
          :label="$t('followOrder.text94')"
        />
        <el-table-column
          min-width="130px"
          prop="applicationTime"
          align="center"
          :label="$t('proxy.text158')"
        />
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        :page-sizes="[10, 50, 100, 200]"
        :disabled="false"
        :background="true"
        layout="total, prev, pager, next, sizes"
        class="pagination-container"
      />
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import apiService from "@/api/request"; // 假设你的 API 请求文件在这个路径
import { useStore } from "vuex";
export default {
  setup() {
    const loading = ref(false);
    const filters = ref({
      webAccount: "",
      customerName: "",
      mt4Account: "",
      depositType: "",
      status: "",
    });
    const depositTypes = ref([]);
    const statuses = ref([]);
    const customerList = ref([]);
    const totalRecharge = ref("0.00USD");
    const totalWallet = ref("0.00USD");
    const netRecharge = ref("0.00USD");
    const pagination = ref({
      currentPage: 1,
      pageSize: 10,
      total: 0,
    });
    const store = useStore();
    const agentConfig = computed(() => store.getters.getAgentConfig);

    // 获取出入金类型和状态
    const fetchBizTypeAndStatus = () => {
      apiService
        .proxyGetBizTypeAndStatus()
        .then((response) => {
          const data = response.data;
          // 填充出入金类型
          depositTypes.value = Object.keys(data.bizType).map((key) => ({
            label: data.bizType[key],
            value: key,
          }));
          // 填充状态
          statuses.value = Object.keys(data.status).map((key) => ({
            label: data.status[key],
            value: key,
          }));
        })
        .catch((error) => {
          console.error("获取出入金类型和状态失败:", error);
        });
    };

    const fetchData = () => {
      loading.value = true;

      const params = {
        fundAccountId: filters.value.webAccount,
        Name: filters.value.customerName,
        mt4LoginId: filters.value.mt4Account,
        bizType: filters.value.depositType,
        Status: filters.value.status,
        page: pagination.value.currentPage,
        limit: pagination.value.pageSize,
      };

      apiService
        .proxyUserMoneyFlow(params)
        .then((response) => {
          const data = response.data;
          customerList.value = data.list;
          totalRecharge.value = data.statis.totalRecharge;
          totalWallet.value = data.statis.totalWallet;
          netRecharge.value = data.statis.netRecharge;
          pagination.value.total = data.count;
        })
        .catch((error) => {
          console.error("API请求错误:", error);
        })
        .finally(() => {
          loading.value = false;
        });
    };

    const handleSearch = () => {
      pagination.value.currentPage = 1;
      fetchData();
    };

    const handleSizeChange = (val) => {
      pagination.value.pageSize = val;
      fetchData();
    };

    const handleCurrentChange = (val) => {
      pagination.value.currentPage = val;
      fetchData();
    };

    const filteredCustomerList = computed(() => {
      return customerList.value;
    });

    onMounted(() => {
      fetchBizTypeAndStatus(); // 获取出入金类型和状态
      fetchData(); // 获取数据
    });

    return {
      loading,
      filters,
      depositTypes,
      statuses,
      customerList,
      totalRecharge,
      totalWallet,
      netRecharge,
      pagination,
      handleSearch,
      handleSizeChange,
      handleCurrentChange,
      filteredCustomerList,
      agentConfig,
    };
  },
};
</script>

<style lang="less" scoped>
</style>
